import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { TellentAssistantEngagementsActions } from './engagements.state';
import { TellentAssistantHttp } from '../tellent-assistant.http';

export const recordTellentAssistantEngagement = createEffect(
  (actions$ = inject(Actions), http = inject(TellentAssistantHttp)) =>
    actions$.pipe(
      ofType(TellentAssistantEngagementsActions.record),
      mergeMap(({ payload }) =>
        http.recordEngagement(payload.id).pipe(
          map(() =>
            TellentAssistantEngagementsActions.recordSuccess({ payload: { id: payload.id } }),
          ),
          catchError(() =>
            of(TellentAssistantEngagementsActions.recordFailed({ payload: { id: payload.id } })),
          ),
        ),
      ),
    ),
  { functional: true },
);
